import MaterialRecord from '@components/containers/catalog/MaterialRecord';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const CatalogMaterial: FC = () => (
    <AppLayout>
        <MaterialRecord />
    </AppLayout>
);

export default CatalogMaterial;
